<template>
  <div class="hello">
    <my-header :activeIndex="2" />
    <div class="main">
      
      <img src="../assets/gift/banner.jpg" style="width: 100%" />
      <div class="center-img">
        <img src="../assets/gift/center.jpg" />
      </div>
    </div>
    <my-footer />
    <my-top />
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: "about",
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
}

.center-img img {
  width: 80%;
}
.center-img {
  background: url(../assets/gift/bg.png);
  background-size: 100%;
  display: flex;
  justify-content: center;
  padding: 10% 0;
}
</style>



// WEBPACK FOOTER //
// src/components/gift.vue